import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';
import groq from 'groq';

export const blockPrivacyControlsSectionFields = groq`
  ...,
  description[] {
    ${portableTextWithReferences}
  }
`;
